function Backside() {
  return (
    <div className="dice-face face--backside">
      <span>BACK</span>
      <span>SIDE</span>
    </div>
  );
}

export default Backside;
